import type { FunctionComponent } from 'react';

import * as Set1 from './set_1';
import * as Set2 from './set_2';
import * as Set3 from './set_3';

// Should Tree-Shaking
const MultiSet = Object.assign({}, Set1, Set2, Set3);
const SvgOutput = Object.keys(MultiSet).reduce((output: string, key: string) => {
  if (typeof MultiSet[key as keyof typeof MultiSet] === 'string') {
    return (
      output +
      MultiSet[key as keyof typeof MultiSet].replace(/xmlns="[^"]+"/, `id="icon-${key}"`).replace(/svg/g, 'symbol')
    );
  } else {
    return output;
  }
}, '');

export const IconRoot: FunctionComponent<{ html?: string }> = ({ html = SvgOutput }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }} dangerouslySetInnerHTML={{ __html: html }} />
  );
};
